// @todo: remove this file
const _logConsole = () => { };

// This function should infallibly handle any garbage passed as params.
const _createMessageForLogging = () => { };

export const postError = () => { };

// WTF
export const callWithoutConsoleLogcallWithoutConsoleLog = (func) => {
  return func();
};

export const log = (e) => {
  console.log(e);
};

export const unitTestPrivate = {
  _createMessageForLogging,
  _logConsole
};
